// Init isotope
$('.isotope-content').wrapAll('<ul id="container-isotope" class="container-isotope"></ul>');

var count = 0;

function ready(){

  count++;

  if(count >= $('.isotope-content img').size()) {
    $('.isotope-content .cube .front').each(function(){
      var size = $(this).height();
      $(this).height(size);
      $(this).parent().height(size);
      $(this).parents('.isotope-content').height(size);
    });

    $('#container-isotope').isotope({
      // options
      itemSelector: '.isotope-content',
      layoutMode: 'masonry',
      masonry: {
        gutter: 31
      },
      sortBy : 'random'
    });
  }
}

$('.isotope-content img').one('load', function() {
  ready();
}).each(function() {
  if(this.complete) $(this).load();
});
